export default __webpack_public_path__ + "static/media/logo-error.eb1f6056.svg";